import { render, staticRenderFns } from "./FeedbackDetails.html?vue&type=template&id=29ae4ea8&scoped=true&external"
import script from "./FeedbackDetails.vue?vue&type=script&lang=js"
export * from "./FeedbackDetails.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDetails.css?vue&type=style&index=0&id=29ae4ea8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae4ea8",
  null
  
)

export default component.exports